import React from 'react';
import { Box, IconButton, Icon } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ClearIconBtn, Container, SearchIconWrap, SearchInput, SearchPaper } from './searchbar.styles';
import { Sort } from './sort';
import { get } from 'global/lib/lodash';
import { Loader } from '../../styles';

export default function SearchBar(props) {
  const { sort, loading } = props;

  const onSearchInputChange = (event) => {
    if (event.target.value) {
      props.changeSearch(event.target.value);
    } else {
      props.changeSearch('');
    }
  };

  const hasClear = get(props, 'onClear');

  // PFM-2599 QA round 2: previous round collapsed the bar to a magnifier icon
  // on xs (<md). Sam reported this hid both Sort By and the clear/reset
  // affordance, so on small screens there was no way to clear an applied
  // filter. Prod kept the search bar fully visible at every breakpoint —
  // restore that behavior here.
  return (
    <Box sx={{ displayPrint: 'none' }}>
      <Container className={props.containerStyle}>
        <SearchPaper>
          {props.SearchIcon && <div>{props.SearchIcon}</div>}
          <SearchIconWrap sidebar={!!props.sidebar}>{!props.SearchIcon && <SearchIcon />}</SearchIconWrap>
          <SearchInput
            placeholder="Search..."
            id="searchInput"
            value={props.searchString}
            onChange={onSearchInputChange}
            sidebar={!!props.sidebar}
            noPaddingLeft={!!props.disableInputPaddingLeft}
          />
          {hasClear && props.searchString && (
            <ClearIconBtn as={IconButton} onClick={props.onClear} size="large">
              {loading ? <Loader size={16} /> : <Icon>clear</Icon>}
            </ClearIconBtn>
          )}
        </SearchPaper>
        {sort && <Sort {...sort} />}
      </Container>
    </Box>
  );
}
